import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  DoubleHorizontalTextSkeleton,
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const SubscriptionCardLoadingMobile: React.FC = () => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.nano">
          <HStack justifyContent="space-between" alignItems="center">
            <DoubleTextSkeleton w="65%" />
            <DetailsSkeleton />
          </HStack>
          <DoubleHorizontalTextSkeleton />
          <DoubleHorizontalTextSkeleton />
          <DoubleHorizontalTextSkeleton />
          <DoubleHorizontalTextSkeleton />
          <DoubleHorizontalTextSkeleton />
          <Stack alignSelf="end" alignItems="end">
            <TextSkeleton w="50px" />
          </Stack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
